<div>
    <mat-sidenav-container [hasBackdrop]="false" autosize style="height: calc(100vh - 50px); width:100%">
        <mat-sidenav #sidenav mode="side" opened style="display: block;">
            <mat-nav-list>
                <a *ngIf="aclGroup.rules" mat-list-item style="height: 30px;" (click)="rules()"><button mat-button
                        style="height: 30px; font-size: 11pt;" class="navbar-items"> Rules</button></a>
                <a *ngIf="aclGroup.externalConnection" mat-list-item style="height: 30px;" (click)="externalConnection()"><button mat-button
                        style="height: 30px; font-size: 11pt;" class="navbar-items"> External Connection</button></a>
            </mat-nav-list>
        </mat-sidenav>
        <mat-sidenav-content style="margin-right: 0; padding:0">
            <div *ngIf="isRules">
                <app-rules-config></app-rules-config>
            </div>
            <div *ngIf="isExternalConn">
                <app-external-conn-config></app-external-conn-config>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>